var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contact-us-container"},[(!_vm.isNativeApp)?_c('client-header',{attrs:{"showMainLogo":_vm.showMainLogo}}):_vm._e(),_c('contact-us'),(!_vm.isNativeApp)?_c('client-footer',{attrs:{"appLinks":_vm.appLinks}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }